import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { UploadCloud, Database, MessageSquare, Phone } from 'lucide-react';
export function IntakeUpload() {
  return <FeaturePageLayout hero={{
    badge: 'Step 3 of 7',
    h1: <>
            Intake &{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-1745">
              Upload
            </span>
          </>,
    subtitle: "We feed your business's historical and operational data into the system so your AI agents learn exactly how your company operates."
  }} problem={{
    subtitle: 'The Data Challenge',
    cards: [{
      icon: <Database className="w-6 h-6 text-teal" data-id="element-1746" />,
      title: 'Siloed Information',
      desc: 'Your company knowledge is scattered across emails, Slack, call recordings, and individual employee brains.'
    }, {
      icon: <MessageSquare className="w-6 h-6 text-purple" data-id="element-1747" />,
      title: 'Lost Context',
      desc: 'Standard AI models lack the specific context of your past customer interactions and internal decisions.'
    }, {
      icon: <UploadCloud className="w-6 h-6 text-blue-400" data-id="element-1748" />,
      title: 'Manual Onboarding',
      desc: 'Training new staff (or AI) usually requires hundreds of hours of manual explanation.'
    }]
  }} solution={{
    badge: 'The Ingestion',
    title: 'Building Your Knowledge Base',
    desc: 'We ingest all your historical communications to build a proprietary knowledge graph that makes your AI uniquely yours.',
    features: [{
      icon: <Phone className="w-6 h-6 text-teal" data-id="element-1749" />,
      title: 'Voice & Video',
      desc: 'We process recorded phone calls and Zoom/Google Meet recordings to understand verbal interactions.'
    }, {
      icon: <MessageSquare className="w-6 h-6 text-purple" data-id="element-1750" />,
      title: 'Text & Chat',
      desc: 'We ingest staff email history, Slack messages, and SMS logs to capture written tone and procedures.'
    }]
  }} data-id="element-1744" />;
}